export default __webpack_public_path__ + "static/media/a028c2b43e7edb9b1f3576d2e9a64e6f.jpg";